




































































import Vue from "vue";
import data from "@/data/photos";
import Album from "@/models/Album";
import Photo from "@/models/Photo";

export default Vue.extend({
  created() {
    const initialData = data;
    Album.insert({ data: initialData });
  },

  computed: {
    albums(): Album[] {
      const dataArray: Album[] =
        Album.query().orderBy("date", "desc").get() || [];
      dataArray?.forEach((data: Album) => {
        data.data =
          data.data?.sort((a, b) => {
            a.folder = b.folder = data.folder;
            return a.pos - b.pos;
          }) || [];
      });
      return dataArray;
    },

    photos(): Photo[] {
      const photos: Photo[] = [];
      this.albums?.forEach((data: Album) => {
        data?.data?.forEach((item: Photo) => {
          item.folder = data.folder;
          photos.push(item);
        });
      });
      return photos;
    },
  },

  data() {
    return {
      slideIndex: 1,
    };
  },

  methods: {
    openModal(): void {
      const myModal: HTMLElement | null = document.getElementById("myModal");
      if (myModal) {
        myModal.style.display = "block";
      }
    },

    closeModal(): void {
      const myModal: HTMLElement | null = document.getElementById("myModal");
      if (myModal) {
        myModal.style.display = "none";
      }
    },

    plusSlides(n: number): void {
      this.showSlides((this.slideIndex += n));
    },

    currentSlide(event: Event): void {
      const hierarchiContainer: HTMLElement | null =
        document.getElementById("hierarchiContainer");
      if (hierarchiContainer) {
        const images: NodeListOf<HTMLElement> =
          hierarchiContainer.querySelectorAll("img");
        if (images.length) {
          const nodes = Array.prototype.slice.call(images);
          const eventElement = event.currentTarget as HTMLElement;
          let slideNum: number = nodes.indexOf(eventElement)
            ? nodes.indexOf(eventElement) + 1
            : 1;
          this.showSlides((this.slideIndex = slideNum));
        }
      }
    },

    showSlides(n: number): void {
      let i;
      const slides: NodeListOf<HTMLElement> =
        document.querySelectorAll(".mySlides");

      if (n > slides.length) {
        this.slideIndex = 1;
      }
      if (n < 1) {
        this.slideIndex = slides.length;
      }

      let slide: HTMLElement;
      let currentSlide: HTMLElement;
      if (slides.length) {
        for (i = 0; i < slides.length; i++) {
          slide = slides[i] as HTMLElement;
          if (slide) {
            slide.style.display = "none";
          }
        }

        currentSlide = slides[this.slideIndex - 1] as HTMLElement;
        if (currentSlide) {
          currentSlide.style.display = "block";
        }
      }
    },

    resetScrollToContainerTop(): void {
      const container: HTMLElement | null =
        document?.querySelector(".container");
      if (container) {
        container.scrollTop = 0;
      }
    },

    getImgUrl(pic: string): any {
      return require(`../assets/images/${pic}`);
    },
  },

  mounted() {
    this.resetScrollToContainerTop();
  },
});
